import type { ReactNode } from 'react';
import { Layout } from '../components/Layout.js';

/**
 * Een module die voor deze organisatie niet aan staat (ADR 0018). De pagina
 * blijft bereikbaar en toont een lege module: zo ziet de organisatie wat er
 * is, en activeren is een betaalde uitbreiding via SUPPOHRT. De backend-
 * modulepoort blijft dicht, dus hier komt nooit data binnen.
 */
export function NietBeschikbaarPage({
  titel,
  omschrijving,
  children,
}: {
  titel: string;
  omschrijving: string;
  /** Wat ondanks de lege module wel zichtbaar is, onder het lege blok. */
  children?: ReactNode;
}): JSX.Element {
  return (
    <Layout>
      <div className="mx-auto max-w-3xl px-4 py-8 sm:px-5">
        <h1 className="text-xl font-bold text-ink-900">{titel}</h1>
        <p className="mt-1 text-[14px] text-ink-900/70">{omschrijving}</p>
        <div className="mt-6 rounded-2xl border border-dashed border-brand-200 bg-white px-6 py-12 text-center">
          <p className="text-[15px] font-semibold text-ink-900">
            {titel} is nog niet geactiveerd voor jouw organisatie.
          </p>
          <p className="mx-auto mt-2 max-w-md text-[14px] text-ink-900/70">
            Wil je {titel} gebruiken? Je organisatie kan dit laten activeren via SUPPOHRT. Vraag de
            beheerder van jouw organisatie om contact op te nemen.
          </p>
        </div>
        {children && <div className="mt-8">{children}</div>}
      </div>
    </Layout>
  );
}
